import React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  required,
} from 'react-admin';

export const ReferralEarningCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="referrer" reference="users" label="Referrer (User)">
        <AutocompleteInput optionText="username" validate={required()} />
      </ReferenceInput>

      <NumberInput source="amount" label="Amount" defaultValue={0} validate={required()} />
    </SimpleForm>
  </Create>
);